import request from "api/axiosClient";

export const getDataTruyCapAPI = async (values) => {
    const result = await request({
        url: "api-access-report/data-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}

export const getGraphicalTruyCapApi = async (values) => {
    const result = await request({
        url: "api-access-report/graphical-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}